import React from "react"
import { Link } from "gatsby"
import Image from "gatsby-image"

import classes from "./navbar.module.scss"
import LanguageSwitcher from "../LanguageSwitcher/languageSwitcher"

const Navbar = props => {
  return (
    <div className={classes.Navbar}>
      <div className={classes.NavbarCenter}>
        <Link to="/">
          <Image fixed={props.logoImg} alt="Yoshi Debat Logo" />
        </Link>
        <LanguageSwitcher />
      </div>
    </div>
  )
}

export default Navbar
